import i18n from 'i18next';
import resource from '@tportal/login/locales/data';

i18n
  .init({
    lng: 'en',
    resources: resource
  });

export default i18n;
